import * as React from "react";
import { SVGProps } from "react";
const SvgCompare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#compare_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m27 6.235 2.658 5.317h-5.316L27 6.235ZM7.658 17.552H2.342L5 12.235l2.658 5.317ZM27 16.999a5 5 0 0 0 5-5 .993.993 0 0 0-.105-.447l-4-8a1.013 1.013 0 0 0-1.158-.518L18.462 5.29A2.993 2.993 0 0 0 16 3.999a2.993 2.993 0 0 0-2.978 2.776L4.737 9.034a1 1 0 0 0-.632.518l-4 8a.993.993 0 0 0-.105.447 5 5 0 0 0 10 0 .993.993 0 0 0-.105-.447l-3.455-6.91 7.098-1.935c.355.51.866.897 1.462 1.109v17.183H5a1 1 0 1 0 0 2h22a1 1 0 0 0 0-2H17V9.816a2.986 2.986 0 0 0 1.978-2.592l6.127-1.672-3 6a.99.99 0 0 0-.105.447 5 5 0 0 0 5 5Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="compare_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCompare;
